import React from 'react';
import styled from 'styled-components';

// Material-UI
import Popover from '@material-ui/core/Popover';
import Fade from '@material-ui/core/Fade';

const MuiPopover = (props) => (
  <Popover
    TransitionComponent={Fade}
    transitionDuration={{ enter: 120, exit: 80 }}
    {...props}
  />
);

// *************************************
// STYLED COMPONENTS                           
// *************************************

// Popover
export const StyledPopover = styled(MuiPopover)`
  .MuiPopover-paper {
    border-radius: 6px;
    box-shadow: ${(props) => props.theme.shadows.depth4};
    background-color: ${(props) => props.theme.colors.white};
  }
`;